import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';

// @ts-ignore
@Component
export default abstract class Element extends Vue {
    public loading: boolean = false;
    public focused: boolean = false;
    public valid: boolean = false;
    public serializedData: any = {};
    public hardValidation: boolean = false;

    @Prop() public integrationData!: any;
    @Prop() public integrationStyles!: any;
    @Prop() public integrationCommonStyles!: any;
    @Prop() public autocomplete!: boolean;

    public input: any = {
        value: '',
        isEmpty: true,
    };
    public abstract toMount(): void;
    public abstract toValidate(): boolean;
    public abstract toClear(): void;
    public abstract toDestroy(): void;
    public abstract toFocus(): void;
    public abstract toBlur(): void;

    get shouldShowValid(): boolean {
        return (( !this.input.isEmpty ) && !this.valid && this.hardValidation ) || this.hardValidation;
    }

    @Emit()
    public serialized(data: any) {
        this.serializedData = data;
    }

    @Watch('input', { deep: true })
    public onInput(value: any) {
        this.hardValidation = false;
        if (typeof value.value === 'string') {
            value.isEmpty = !value.value.length;
        }
        this.serialized({
            ...value,
            valid: this.validate(this.hardValidation),
        });
    }

    @Watch('loading')
    public onLoading(value: boolean) {
        this.$emit('loading', value);
    }

    public onFocus() {
        this.$emit('focus');
        this.focused = true;
    }

    public onBlur() {
        this.$emit('blur');
        this.focused = false;
        this.validate(!this.input.isEmpty, this.valid);
    }

    protected validate(hard?: boolean, withoutAction?: boolean) {
        try {
            const valid: boolean = this.toValidate();
            this.valid = valid;
            // TODO $emit('valid') should be refactored to use only with serialized
            if (hard) {
                this.hardValidation = hard;
                if (!withoutAction) {
                    this.$emit('valid', valid);
                }
            }
            if (!withoutAction || this.input.isEmpty && hard) {
                if (valid && this.focused) {
                    this.hardValidation = false;
                    this.$emit('valid', true);
                } else if (!valid && this.focused) {
                    this.$emit('valid', false);
                } else if (this.input.isEmpty && hard) {
                    this.$emit('valid', valid);
                }
            }
            return valid;
        } catch (e) {
            this.doError(e);
        }
    }

    protected clearData() {
        try {
            this.hardValidation = false;
            return this.toClear();
        } catch (e) {
            this.doError(e);
        }
    }

    private destroyed() {
        try {
            return this.toDestroy();
        } catch (e) {
            this.doError(e);
        }
    }

    private focus(event?) {
        try {
            return this.toFocus();
        } catch (e) {
            this.doError(e);
        }
    }

    private blur() {
        try {
            return this.toBlur();
        } catch (e) {
            this.doError(e);
        }
    }

    private mounted() {
        try {
            if (this.$refs.cardType && this.$refs.holder) {
                this.$nextTick(() => {
                    (this.$refs.cardType as any).$el.style.position = 'absolute';
                    (this.$refs.cardType as any).$el.style.bottom = '0px';
                    (this.$refs.holder as any).style.position = 'relative';
                    (this.$refs.input as any).style['padding-left'] = `
                    ${(this.$refs.cardType as any).$el.clientWidth}px`;
                });
            }
            this.toMount();
        } catch (e) {
            this.doError(e);
        }
    }

    private doError(e: any) {
        this.$emit('error');
        this.loading = false;
        // tslint:disable-next-line
        console.error(e);
    }
}
